import { getFirebaseApp } from "./firebaseClient";

let analyticsInitPromise = null;

const isDoNotTrackEnabled = () => {
  const dnt =
    navigator?.doNotTrack ||
    window?.doNotTrack ||
    navigator?.msDoNotTrack;
  return dnt === "1" || dnt === "yes";
};

const canUseAnalytics = () => {
  if (typeof window === "undefined") return false;
  if (isDoNotTrackEnabled()) return false;
  if (!process.env.FIREBASE_MEASUREMENT_ID) return false;
  return true;
};

const initAnalytics = async () => {
  if (!canUseAnalytics()) return null;
  if (analyticsInitPromise) return analyticsInitPromise;

  analyticsInitPromise = (async () => {
    const app = getFirebaseApp();
    if (!app) return null;

    const { isSupported, getAnalytics } = await import("firebase/analytics");
    const supported = await isSupported().catch(() => false);
    if (!supported) return null;

    return getAnalytics(app);
  })();

  return analyticsInitPromise;
};

export const trackPageView = async (pageTitle = document.title) => {
  const analytics = await initAnalytics();
  if (!analytics) return;

  const { logEvent } = await import("firebase/analytics");
  logEvent(analytics, "page_view", {
    page_title: pageTitle,
    page_location: window.location.href,
    page_path: window.location.pathname + window.location.search + window.location.hash,
  });
};

export const trackEvent = async (name, params = {}) => {
  const analytics = await initAnalytics();
  if (!analytics) return;

  const { logEvent } = await import("firebase/analytics");
  logEvent(analytics, name, params);
};

